module.exports = "<app-viewer-header [title]=\"'Stadium Camera Details'\" [hideOptions]=\"true\" *ngIf=\"!fullScreenMode\" >\n  <div  class=\"content mr-4\">\n    <app-asset-action [asset]=\"stadiumData\" [type]=\"'dropdown'\">\n    </app-asset-action>\n  </div>\n</app-viewer-header>\n<app-stadium-camera-360 [ngClass]=\"fullScreenMode?'fullScreen':'normal'\"  [stadium]=\"stadium\" *ngIf=\"stadium\" ></app-stadium-camera-360>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/stadium/stadium.component.html
// module id = ./src/app/views/stadium/stadium.component.html
// module chunks = main